import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Form, ListGroup, Spinner } from "react-bootstrap";
import { manufacturersList } from "../utils/search-autocomplete";

const data = [
    { id: 1, name: "devrecipes.net" },
    { id: 2, name: "devrecipes" },
    { id: 3, name: "devrecipe" },
    { id: 4, name: "dev recipes" },
    { id: 5, name: "development" }
];

const SearchComponent = (props: any) => {
    
    const { t, i18n } = useTranslation();
    const resentSearchesLbl = i18n.exists("pages.resentSearchesLbl") ? t('pages.resentSearchesLbl') : "Начало";
    let [searchValue, setSearchValue] = useState('');
    let [filteredArray, setFilteredArray] = useState([]);
    const [isFiltered, setIsFiltered] = useState(false);
    const [lastSearch, setLastSearch] = useState(false);
    const [storedSearchItems, setSearchItems] = useState([]);
    const [results, setResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    let [name, setName] = useState("");
    const [isNameSelected, setIsNameSelected] = useState(false);

    const mockResults = (keyword:any) => {
        return new Promise((res, rej) => {
            setTimeout(() => {
            const list: any = manufacturersList;
            const searchResults = list.filter((item: any) => {
                    return (item.manufacturer && item.manufacturer.toLowerCase().indexOf(keyword.toLowerCase()) !== -1) || 
                            (item.notes && item.notes.toLowerCase().indexOf(keyword.toLowerCase()) !== -1)
                });
            res(searchResults);
            }, 500);
        });
    };

    const handleInputChange = (e: any) => {
        const nameValue = e.target.value;

        setName(nameValue);
        // even if we've selected already an item from the list, we should reset it since it's been changed
        setIsNameSelected(false);
        // clean previous results, as would be the case if we get the results from a server
        setResults([]);
        if (nameValue.length > 2) {
            //const results: any = manufacturersList;
            //setResults(results);

            setIsLoading(true);
            mockResults(nameValue)
                .then((res: any) => {
                    //const uniqueArray = res.map((item: any) => item.manufacturer)
                    //.filter((value: any, index: any, self: any) => self.indexOf(value) === index)
                    const uniqueValues = res.reduce((acc: any, obj: any) => {
                        if (!acc.some((item: any) => item.manufacturer === obj.manufacturer)) {
                            acc.push(obj);
                        }
                        return acc;
                    }, []);

                    // const uniqueValues: any = Array.from(new Set(res.map((obj: any) => JSON.stringify(obj))))
                    // .map((e: any) => JSON.parse(e));
                    
                    setResults(uniqueValues);
                    setIsLoading(false);
                })
                .catch(() => {
                setIsLoading(false);
            });
        }
        handleChange(e);
    };

    const onNameSelected = (selectedName: any) => {
        setSearchValue(selectedName);
        searchValue = selectedName;
        setName(selectedName);
        name = selectedName;
        setIsNameSelected(true);
        setResults([]);
        handleSearch();
        
    };

    const filterValue = (value: any, source: any) => {
        let result: any = source.filter((item: any) => {
            const notesObj = JSON.parse(item.notes);
            const notesArr = Object.values(notesObj);
           // console.log(notesArr)
            const filterObj = (arr: any, searchKey: any) => {
                return arr.filter((item: string) => {
                    return item.toLowerCase() === searchKey.toLowerCase();
                })
              }
              //console.log(item.manufacturer);
            if((item.manufacturer && item.manufacturer.toLowerCase().indexOf(value.toLowerCase()) !== -1) 
                //|| (filterObj(notesArr, value))
                || (item.notes && item.notes.toLowerCase().indexOf(value.toLowerCase()) !== -1)
            ) {
                return item;
            }
        });
        return result;
    }
    const handleChange= (e: any) => {
        setSearchValue(e.target.value);
    }

    const handleKeyUp = (e: any) => {
        if(e.keyCode === 13) {
            handleSearch();
        }
        if(searchValue.length === 0) {
            clearSearch();
        }
    }

    const handleSearch = () => {
        if(searchValue.length > 0) {
            if(props.dataSource && props.dataSource.length > 0) {
                setIsFiltered(true);
                setFilteredArray(filterValue(searchValue, props.dataSource));
                filteredArray = filterValue(searchValue, props.dataSource);
                props.filterArray(filteredArray);
                console.log(name)
                addSearch(searchValue);
            }
        }
        else {
            clearSearch();
        }
        props.searchValue(searchValue);
    }

    const clearSearch = () => {
        if(isFiltered) {
            const sliced = props.dataSource.slice(0, 60);
            props.filterArray(sliced);
            props.isClear(true);
        }
        setSearchValue('');
        //setLastSearch(false);
        props.isSearchPerf(false);
    }

    const checkLastSearch = () => {
        const searchItems: any = localStorage.getItem('searchItems');
        if(searchItems) {
            let sItems = JSON.parse(searchItems);
            setSearchItems(sItems);
            if(searchItems.length > 0) {
                setLastSearch(true);
            }
            else {
                setLastSearch(false);
            }
            return sItems;
        }
        return [];
    }

    const performSearch = (e: any, value: string) => {
        if(e.target.className.indexOf('perform-search') !== -1) {
            setSearchValue(value);
            searchValue = value;
            handleSearch();
        }
    }

    const removeSearch = (s: any) => {
        console.log(s)
        let searchItems: any = [...storedSearchItems];
        const filteredItems = searchItems.filter((sItem: any) => {
            return sItem !== s;
        })
        localStorage.setItem('searchItems', JSON.stringify(filteredItems));
        checkLastSearch();
    }

    const addSearch = (value: string) => {
        let items = [...checkLastSearch()];
        if(items) {
            if(items.indexOf(value) === -1) {
                // 5 items max
                if(items.length > 4) {
                    items.pop();
                }
                items.unshift(value);
            }
        }
        localStorage.setItem('searchItems', JSON.stringify(items));
        checkLastSearch();
    }


    return (
        <div className="bl-search">
            <span className="search-btn" onClick={handleSearch}></span>
            <input disabled={props.disabled} value={searchValue} type="search" className="search-control" onChange={(e) => handleInputChange(e)} onKeyUp={handleKeyUp} onClick={checkLastSearch} />
            
            <Form.Group className="typeahead-form-group">
                {/* <Form.Control
                    type="text"
                    autoComplete="off"
                    onChange={handleInputChange}
                    onKeyUp={handleKeyUp} 
                    onClick={checkLastSearch}
                    value={name}
                /> */}
                <ListGroup className="typeahead-list-group">
                {!isNameSelected &&
                    results.length > 0 &&
                    results.map((result: any) => (
                    <ListGroup.Item
                        key={result.id}
                        className="typeahead-list-group-item"
                        onClick={() => onNameSelected(result.manufacturer)}
                    >
                        {result.manufacturer}
                    </ListGroup.Item>
                    ))}
                {!results.length && isLoading && (
                    <div className="typeahead-spinner-container">
                    <Spinner animation="border" />
                    </div>
                )}
                </ListGroup>
            </Form.Group>
            
            {lastSearch ? (
                <div>
                    {storedSearchItems.length > 0 ? (
                        <div className="search-items">
                            <h3>{resentSearchesLbl}</h3>
                            <ul>
                                {storedSearchItems.map((item, index) => {
                                    return (
                                        <li className="perform-search" key={index} onClick={(e) => performSearch(e, item)}>{item}<span className="remove-search-btn" onClick={() => removeSearch(item)}>x</span></li>
                                    )
                                })}
                            </ul>
                        </div>
                    ) : null}
                </div>
            ) : null }
            {searchValue.length > 0 ? (
                <span className="clear-search-btn" onClick={clearSearch}>x</span>
            ): null}
        </div>
    )
}
export default SearchComponent;